import React, { useState, useEffect, useCallback } from 'react';
import { Button, Space, Breadcrumb, Table } from 'antd';
import { CardLayout, MailTemplateEditModal } from 'components/molecules';
import { useTableInfo, useMailTemplate } from 'hooks';
import { useLocation, useNavigate } from 'react-router';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { usePopupManager } from 'react-popup-manager';
import { TableWrapper } from 'components/molecules';
import SearchBox from './SearchBox'
import { INIT_PAGESIZE } from 'commons/constants';
import qs from 'query-string';
import { addNewSearch } from 'utils/utils';

export interface  MailCommonProps {}

const  MailCommon = ({}:  MailCommonProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();  
  const { open } = usePopupManager();
  const searchParams = qs.parse(location.search);

  const columns: ColumnsType<MailTemplateDto> = [
    {
      title: '메일그룹명',
      dataIndex: 'mail_group_name',
      key: 'mail_group_name',
      width: '150px',
      align: 'center',
    },    
    {
      title: '메일유형',
      key: 'mail_type_title',
      dataIndex: 'mail_type_title',
      width: '150px',
      align: 'center',
    },  
    {
      title: '메일유형명',
      key: 'mail_type_name',
      dataIndex: 'mail_type_name',
      width: '200px',
      align: 'left',
    },      
    {
      title: '받는사람',
      key: 'mail_to',
      dataIndex: 'mail_to',
      width: '200px',
      align: 'left',
    },      
    {
      title: '참조',
      key: 'mail_cc',
      dataIndex: 'mail_cc',
      width: '200px',
      align: 'left',
    },              
    {
      title: '메일제목',
      dataIndex: 'subject',
      key: 'subject',
      width: 'auto',
      align: 'left',
    }, 
  ];
    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { tmpplateList, searchResult, refetch } = useMailTemplate();  

  /* ======================================================
   * events
   * ====================================================== */    

  const onClickRegister = () => {
    open(MailTemplateEditModal, {
      id: 0,
      mail_type : '',      
      onClose: (isOk) => {
        if (isOk) {
          refetch();
        }
      },
    }); 
  }

  const onRowClick = useCallback((record, index) => {
    return {
      onClick: () => {
        open(MailTemplateEditModal, {
          id: record.id,
          mail_type: record.mail_type,      
          onClose: (isOk) => {
            if (isOk) {
              refetch();
            }
          },
        });        
      },
    };
   }, []);

   const onChangePageInfo = (pageNo: number, pageSize: number) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { pageNo, pageSize }),
    });
  };  

   const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: tmpplateList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });   

 
  /* ======================================================
   * effects
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2C</Breadcrumb.Item>
        <Breadcrumb.Item>메일 템플릿 관리</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <TotalNumMenu totalNum={searchResult.totalCount} useRegister onUseRegister={onClickRegister} />
          <TableWrapper isSearch={false}>
            <Table
              dataSource={tmpplateList}
              columns={columns}
              pagination={pagination}
              onChange={onTableChange}
              style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
              className="columnCenterFixTable"
              onRow={onRowClick}
            />          
          </TableWrapper> 
      
        </Space>            
    </CardLayout>
  )
};

export default  MailCommon;    